

import {TranslationMessagePage} from "./translation-messages-page";

/**
 * An array of data with an associated page object used for paging
 */
export class TranslationMessagesPageData<T> {
    data = new Array<T>();
    page = new TranslationMessagePage();
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/translation-messages/translation-messages/translation-messages.ts